export default __webpack_public_path__ + "static/media/right_arrow_white.865fbf9a.svg";